import { css } from '@emotion/css';

export const absoluteCenter = css`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;
